import { makeAutoObservable } from "mobx";
import { getCurrentMode } from "n24-ui/fn";
import { RootStore } from "./root.store";

export class UIStore {
  rootStore: RootStore;
  loading: boolean = true;
  error: string = "";
  mode: "light" | "dark" = "dark";
  preferredListView: "list" | "grid" = "grid";
  processes: string[] = [];

  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
    this.onModeSwitch();
  }

  handleError(msg: string, error?: string) {
    this.error = msg;
    console.error(error);
  }

  dismissError() {
    this.error = "";
  }

  onModeSwitch() {
    this.mode = getCurrentMode() as "light" | "dark";
  }

  setListView(newValue: typeof this.preferredListView) {
    this.preferredListView = newValue;
  }

  toggleProcessLoading(processId: string, state: boolean) {
    this.processes = state
      ? [...this.processes, processId]
      : this.processes.filter((id) => id !== processId);
  }
}
